__turbopack_context__.v({
  "badges": "ProductCardSkeleton-module-scss-module__kQK7WG__badges",
  "body": "ProductCardSkeleton-module-scss-module__kQK7WG__body",
  "card": "ProductCardSkeleton-module-scss-module__kQK7WG__card",
  "fade-in": "ProductCardSkeleton-module-scss-module__kQK7WG__fade-in",
  "footer": "ProductCardSkeleton-module-scss-module__kQK7WG__footer",
  "no-transform": "ProductCardSkeleton-module-scss-module__kQK7WG__no-transform",
  "rotate": "ProductCardSkeleton-module-scss-module__kQK7WG__rotate",
  "title": "ProductCardSkeleton-module-scss-module__kQK7WG__title",
});
